(function () {
  'use strict';

  //
  // Populate the countries dropdown
  //

  var jsonData = require('./countries-list.json');

  // Get the select and dropdown elements
  var selectElements = document.querySelectorAll('.js-countries-list-select');
  var dropdownElements = document.querySelectorAll(
    '.js-countries-list-dropdown'
  );

  // Loop through the JSON data and create options for the select element
  selectElements.forEach((select) => {
    for (var i = 0; i < jsonData.length; i++) {
      var option = document.createElement('option');
      option.value = jsonData[i].Code.toLowerCase();
      option.textContent = jsonData[i].Name;
      select.appendChild(option);
    }
    select.querySelector(':first-child').setAttribute('selected', 'selected');
  });

  // Loop through the JSON data and create options for the dropdown element
  dropdownElements.forEach((dropdown) => {
    for (var i = 0; i < jsonData.length; i++) {
      var optionDD = document.createElement('div');
      optionDD.className = 'sq-form-question-select-option';
      optionDD.setAttribute('data-value', jsonData[i].Code.toLowerCase());
      optionDD.textContent = jsonData[i].Name;

      dropdown.appendChild(optionDD);
    }
    dropdown
      .querySelector(':first-child')
      .setAttribute('data-selected', 'true');
  });

  //
  // Logic for dropdown actions
  //

  const modifiedSelectWrappers = document.querySelectorAll(
    '.sq-form-question-select-wrapper'
  );
  if (!modifiedSelectWrappers.length) return;

  const setDropdownStatus = (dropdown) => {
    const options = dropdown.querySelectorAll(
      '.sq-form-question-select-option'
    );
    const select = dropdown.parentElement.querySelector('select');
    let filteringWord = '';
    const keyNavigation = (option) => {
      const closeDropdownEvent = new KeyboardEvent('keydown', {
        code: 'Escape',
      });
      return (e) => {
        e.preventDefault();
        if (e.code === 'Escape' || e.code === 'Tab')
          select.dispatchEvent(closeDropdownEvent);
        if (e.code === 'Space' || e.code === 'Enter') {
          // since this is a click/key event, the dropdown is already active, but the class is removed in the next line
          dropdown.classList.add('active');
          option.dispatchEvent(new MouseEvent('click'));
        }
        if (e.key === 'ArrowDown') {
          const nextOption = option.nextElementSibling;
          if (nextOption) nextOption.focus();
        }
        if (e.key === 'ArrowUp') {
          const previousOption = option.previousElementSibling;
          if (previousOption) previousOption.focus();
        }

        const filterOptions = (e) => {
          const isLetterOrNumber = /^[a-zA-Z0-9]$/.test(e.key);
          if (!isLetterOrNumber) return;
          filteringWord += e.key;
          setTimeout(() => {
            filteringWord = '';
          }, 2000);

          const foundOption = Array.from(options).find((option) =>
            option.innerText.toLowerCase().startsWith(filteringWord)
          );

          if (foundOption) {
            foundOption.focus();
          }
        };
        filterOptions(e);
      };
    };
    if (!dropdown.classList.contains('active')) {
      options.forEach((option) => {
        option.setAttribute('tabindex', 0);
        option.addEventListener('keydown', keyNavigation(option));
      });
      dropdown.classList.add('active');
      dropdown.setAttribute('aria-hidden', false);
      dropdown.setAttribute('aria-expanded', true);
      options[0].focus();
      return;
    }

    options.forEach((option) => {
      option.setAttribute('tabindex', -1);
      option.removeEventListener('keydown', keyNavigation(option));
    });
    dropdown.classList.remove('active');
    dropdown.setAttribute('aria-hidden', true);
    dropdown.setAttribute('aria-expanded', false);
    select.focus();
  };

  modifiedSelectWrappers.forEach((wrapper) => {
    const select = wrapper.querySelector('select');
    const dropdown = wrapper.querySelector('.sq-form-question-select-dropdown');
    const options = wrapper.querySelectorAll('.sq-form-question-select-option');
    select.addEventListener('keydown', (e) => {
      if (
        e.code === 'Space' ||
        e.code === 'ArrowDown' ||
        e.code === 'ArrowUp'
      ) {
        e.preventDefault();
        setDropdownStatus(dropdown);
      }

      if (e.code === 'Escape' && dropdown.classList.contains('active')) {
        e.preventDefault();
        setDropdownStatus(dropdown);
      }
    });

    select.addEventListener('mousedown', (e) => {
      e.preventDefault();
      setDropdownStatus(dropdown);
    });

    options.forEach((option) => {
      option.addEventListener('click', () => {
        select.value = option.getAttribute('data-value');
        setDropdownStatus(dropdown);
      });
    });
  });
})();
